const DEFAULT_CURSOR = "auto";

const HitAreas = {
    TOP: "t",
    BOTTOM: "b",
    RIGHT: "r",
    LEFT: "l",
    TOPLEFT: "tl",
    TOPRIGHT: "tr",
    BOTTOMLEFT: "bl",
    BOTTOMRIGHT: "br",
    CENTER: "c",
    isCorner: function( area ) {
        return area === this.TOPRIGHT || area === this.TOPLEFT || area === this.BOTTOMLEFT || area === this.BOTTOMRIGHT;
    },
    isEdge: function( area ) {
        return area === this.TOP || area === this.BOTTOM || area === this.LEFT || area === this.RIGHT;
    },
    getCursor: function( area ) {
        var rotated = false;// viewer.openseadragon.viewport.getRotation() % 180 === 90;
        if ( area === this.TOPLEFT || area === this.BOTTOMRIGHT ) {
            return rotated ? "nesw-resize" : "nwse-resize";
        }
        else if ( area === this.TOPRIGHT || area === this.BOTTOMLEFT ) {
            return rotated ? "nwse-resize" : "nesw-resize";
        }
        else if ( area === this.TOP || area === this.BOTTOM ) {
            return rotated ? "ew-resize" : "ns-resize";
        }
        else if ( area === this.RIGHT || area === this.LEFT ) {
            return rotated ? "ns-resize" : "ew-resize";
        }
        else if ( area === this.CENTER ) {
            return "move";
        }
        else {
            return DEFAULT_CURSOR;
        }
    }
}

export default HitAreas;